var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newAddHomeItem"},[_c('tab',{attrs:{"titleName":_vm.title,"list":_vm.cityList}}),_c('div',{staticClass:"training"},[_c('TrainTest',{attrs:{"title":_vm.title2,"name":'zlhz'}})],1),_c('div',{staticClass:"zjltBox"},[_c('qutab',{attrs:{"titleName":_vm.title3,"list":_vm.problemList,"id":'cjwt'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }